// Phase 6 — guard for admin-only routes. Non-admins are bounced to /dashboard with a toast.
import { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/contexts/AuthContext";

export default function RequireAdmin({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  useEffect(() => {
    if (!loading && user && !user.is_admin) {
      toast.error("Admin access required.");
    }
  }, [loading, user]);

  if (loading) return null;
  if (!user) return <Navigate to="/login" replace state={{ from: location }} />;
  if (!user.is_admin) return <Navigate to="/dashboard" replace />;
  return children;
}
